export const lightTheme = {
    style: 'light',
    background: '#fff',
    color: '#1e1e1e'
} as const;

export const darkTheme = {
    style: 'dark',
    background: '#1e1e1e',
    color: '#fff'
} as const;
